// check if an element is inside the boundingClientRect of another element,
// e.g. to check if a selection has been dragged onto the map. 'x' and 'y'
// values from getBoundingClientRect are incompatible with several browsers.
// Use the equivalent 'left' and 'top' values instead.

export const isWithinBounds = (draggableRef, boundaryRef) => {
  const {
    left: x1,
    top: y1,
    width,
    height,
  } = boundaryRef.getBoundingClientRect();
  const { left: x, top: y } = draggableRef.getBoundingClientRect();
  const x2 = x1 + width,
    y2 = y1 + height;

  return x > x1 && x <= x2 && y >= y1 && y <= y2;
};

// map asbolute coordinates into a specific element's bounding rect

export const translatePosition = (draggableRef, boundaryRef) => {
  const { left: boundX, top: boundY } = boundaryRef.getBoundingClientRect();
  const {
    left: dragX,
    top: dragY,
    width,
    height,
  } = draggableRef.getBoundingClientRect();

  const x = dragX - boundX,
    y = dragY - boundY;

  return { x, y, height, width };
};

// offset the x and y coordinates based on direction keys
export const setPosition = (item, direction, value) => {
  if (direction === 'up') {
    item.y = item.y - value;
  }
  if (direction === 'down') {
    item.y = item.y + value;
  }
  if (direction === 'left') {
    item.x = item.x - value;
  }
  if (direction === 'right') {
    item.x = item.x + value;
  }
};
